function ogFormfield() {
  return {
    restrict: 'E',
    scope: {},
    require: ['ogFormfield', '^^form'],
    link: function($scope, $element, $attrs, [myCtrl, formCtrl]) {
      $scope.$watchCollection(() => [myCtrl.isRequired, myCtrl.isDisabled], ([isRequired, isDisabled]) => {
        $element.toggleClass('og-required', Boolean(isRequired));
        $element.toggleClass('og-disabled', Boolean(isDisabled));
      });

      $scope.$watchCollection(() => formCtrl[myCtrl.fieldName], (field) => {
        if (field) {
          $element.toggleClass('ng-invalid', field.$invalid);
          $element.toggleClass('ng-touched', field.$touched);
        }
      });
    },
    controller: function() {}
  };
}

ogFormfield.$inject = [];

module.exports = ogFormfield;
